import { generateTableSlice } from "./sliceTable";

const sliceBillingInvoiceTable = generateTableSlice("billingInvoice");
export const ActionsBillingInvoiceTable = sliceBillingInvoiceTable.actions;
export const ReducerBillingInvoiceTable = sliceBillingInvoiceTable.reducer;
